module.exports = __webpack_public_path__ + "img/tree-09-d-leaves.33d5083f.png";